export const TAG_REGEX = /([\w]+(,|\n))/g;
